import {
    OrderStatuses,
    getOrderStatusGroup,
} from 'entities/Order/model/consts/orderStatuses';

/**
 * Checks if an order has been submitted (PROCESSING, SHIPPED, or INVOICED)
 * Uses statusMapping to intelligently map sub-statuses to their parent groups
 * @param orderStatus - The status of the order
 * @returns true if the order is submitted, false otherwise
 */
export const isOrderSubmitted = (
    orderStatus?: OrderStatuses | string,
): boolean => {
    if (!orderStatus) {
        return false;
    }

    const statusGroup = getOrderStatusGroup(orderStatus);

    return (
        statusGroup === OrderStatuses.PROCESSING ||
        statusGroup === OrderStatuses.SHIPPED ||
        statusGroup === OrderStatuses.INVOICED
    );
};
